export const CONVERSATION_RELOAD = 'conversationReload';
export const ACCOUNT_CHANGE = 'accountChange';
export const MESSAGE_RELOAD = 'messageReload';

export const FILTER_RELOAD = 'filterReload';
export const UNREAD_CHECK_EVENT = 'unreadCheckEvent';

export const ACTIVE_CONVERSATION_CHANGED = 'activeConversationChangedEvent';
